import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NewMediaComponent } from '../../shared/dialogs/new-media/new-media.component';
import { first, firstValueFrom } from 'rxjs';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { ProjectMedia } from 'src/app/models/project.model';
import { ProjectsService } from 'src/app/services/projects.service';
import { CutoffService } from 'src/app/services/cutoff.service';
import { MainService } from 'src/app/services/main.service';
import { ProjectsListCloneMedioComponent } from '../../shared/dialogs/project-list-clone-medio/project-list-clone-medio.component';
import Swal from 'sweetalert2';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';



@Component({
  selector: 'app-project-media',
  templateUrl: './project-media.component.html',
  styleUrls: ['./project-media.component.scss']
})
export class ProjectMediaComponent implements OnInit {
  //reglas Medios 
  //1 - reglas
  //2 - prioridad 

  // Data Handlers
  projectID: number | null = null;
  projectMedia : Array<any> = [];
  dataSource!: MatTableDataSource<any>;
  displayedColumns: string[] = ['id', 'nombre', 'multiples_elementos', 'sucursales_vacias', 'segmentable', 'formato', 'actions'];
  projectData : any;
  //@ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild("pagi") paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(private dialog: MatDialog,
     private route: ActivatedRoute, 
     private router: Router, 
     private projService : ProjectsService,
     private _cutoffS : CutoffService,
     private _main :  MainService,
     private cdr: ChangeDetectorRef) 
     {

      }

  ngOnInit(): void {
    this.getData();
  }

  hasPermissions(key : string, buho : boolean|any, client : boolean|any):  boolean {
    return this.projService.hasPermissions(key, buho, client);
  }

  /* void openMediaPOP(1):
      */
  openMediaPOP(id: number): void {
    this.router.navigateByUrl('/admin/projects/project/' + this.projectID + '/media/' + id);
  }


  /* async Promise<void> getData(0):
     Extracts data from URL. */
  async getData(): Promise<void> {
    try {
      // Extract ID
      const url: ParamMap = await firstValueFrom(this.route.paramMap);
      this.projectID = Number(url.get('id'));
   
      if (!this.projectID){
        Swal.fire({
          icon: 'error',
          title: 'Error al obtener registros',
          text: 'Ocurrió un error al obtener registros, no existe un id válido.'
        });
      }else{
        this._main.ShowLoading();
        this.projService.getMedios(this.projectID).subscribe((x: any) => {
          this._main.HideLoading();
          this.projectMedia = x.data.medios;
          this.dataSource = new MatTableDataSource(this.projectMedia);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.projectData = x.data.proyecto;
          console.log("this proyect", this.projectData);
          //ESTO DEBE DE ESTAR EN TODAS LOS COMPONENTESD DE PROYECTOS
          this._cutoffS.checkIfSameProjectThenReplace(x.data.proyecto.id_proy_camp);

        },
        (err:any) => {
          console.log(err);
              this._main.HideLoading();
              Swal.fire({
                icon: 'error',
                title: 'Error al obtener registros',
                text: 'Ocurrió un error al obtener registros, vuelva a intentarlo más tarde.'
              });
        });
      }
       
    } catch (error) {
      console.error(error);
    }
  }

  async newMedia(): Promise<void> {

    const nmDialogRef: MatDialogRef<NewMediaComponent, any> = this.dialog.open(NewMediaComponent, {
      data: { id_proyecto : this.projectID, id_proy_camp: this.projectData.id_proy_camp, medios : this.projectMedia, isEdit: false},
      panelClass: 'dialogs-main'
    });

    try {
      // Use firstValueFrom to get the result from the dialog
      const result = await firstValueFrom(nmDialogRef.afterClosed());
      this.getData();
      if (result) {
        console.log('Dialog result:', result);
      }
    } catch (error) {
      console.error('Error handling dialog result:', error);
    }
  }

  async editMedia( medio : any): Promise<void> {
    // Open data-setting dialog
    const nmDialogRef: MatDialogRef<NewMediaComponent, any> = this.dialog.open(NewMediaComponent, {
      data: { id_proyecto : this.projectID, id_proy_camp: this.projectData.id_proy_camp, medios : this.projectMedia, isEdit: true, medio : medio},
      panelClass: 'dialogs-main'
    });

    try {
      // Use firstValueFrom to get the result from the dialog
      const result = await firstValueFrom(nmDialogRef.afterClosed());
      this.getData();
      if (result) {
        console.log('Dialog result:', result);
      }
    } catch (error) {
      console.error('Error handling dialog result:', error);
    }
  }


  openDialogClone() {
    this.dialog.open(ProjectsListCloneMedioComponent, {
      panelClass: ['dialogs-md'],
      data: {
        proyecto_id : this.projectID,
      }
    }).afterClosed().subscribe(
      resp => {
        this.getData();
      }
    );
  }

  deleteConfirm(medio: any){
    Swal.fire({
      title: '¿Está seguro que desea eliminar este medio?. Esto no se puede deshacer.',
      icon: 'warning',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar'
    })
  .then((willDelete) => {
    if (willDelete.isConfirmed) {
      this._main.ShowLoading();
      this.projService.deleteMedios(medio.id).subscribe(
        (x: any) => {
          this._main.HideLoading();
          this.getData();
        },
        (err:any) => {
          this._main.HideLoading();
          Swal.fire({
            icon: 'error',
            title: 'Error al eliminar',
            text: 'Ocurrió un error al eliminar el registro, por favor vuelva a intentarlo.'
          });
          //this.loadCampaigns();
          this.getData();
        }
      );
    }
  });
  }

  applyFilter(event: Event, ds: any) {
    const filterValue = (event.target as HTMLInputElement).value;
    ds.filter = filterValue.trim().toLowerCase();
    if (ds.paginator) ds.paginator.firstPage();
  }
}
